module.exports = __webpack_public_path__ + "media/images/home/icon-analytics-24fbfa0cebc34bece4ffb923b5103247.png";